
import React from 'react';
import { getColorForElement } from '@/utils/debug/debugUtils';

interface ElementPosition {
  element: string;
  top: number;
  left: number;
  width: number;
  height: number;
}

interface LayerPositionIndicatorsProps {
  elementPositions: ElementPosition[];
}

/**
 * Visualizes layer positions for debugging
 */
export const LayerPositionIndicators: React.FC<LayerPositionIndicatorsProps> = ({ 
  elementPositions 
}) => {
  return (
    <>
      {elementPositions.map((pos, index) => (
        <div 
          key={index}
          className="layer-debug-outline"
          style={{
            position: 'fixed',
            top: `${pos.top}px`,
            left: `${pos.left}px`,
            width: `${pos.width}px`,
            height: `${pos.height}px`,
            border: `2px solid ${getColorForElement(pos.element)}`,
            zIndex: 9999,
            pointerEvents: 'none',
            boxSizing: 'border-box'
          }}
        >
          <div style={{
            position: 'absolute',
            top: '-20px',
            left: '0',
            backgroundColor: getColorForElement(pos.element),
            color: 'white',
            padding: '2px 4px',
            fontSize: '10px',
            whiteSpace: 'nowrap'
          }}>
            {pos.element} (T:{pos.top})
          </div>
        </div>
      ))}
    </>
  );
};
